module.exports = __webpack_public_path__ + "static/world-76ddcb1ab2ac399b1a353acb7f52a531.svg";